import * as logOutActions from '../../src/store/logout/actions'
import {connect} from 'react-redux'
import NavBar from '../components/nav-bar'

export default connect((state) => {
  return {
    isTokenRefreshed: state.refreshToken.isTokenRefreshed,
  }
}, logOutActions)(NavBar)



// WEBPACK FOOTER //
// ./src/containers/nav-bar-container.js